import React, { useContext } from "react";

export type DefaultContext = {
  data: number[];
  labels: string[];
  colors?: string[];
  title?: string;
  unit?: string;
  icon?: JSX.Element;
};

const RootElementContext = React.createContext<DefaultContext>(
  {} as DefaultContext,
);
const useRootElement = () => useContext(RootElementContext);

export { useRootElement, RootElementContext };
